import React, { useEffect, useState } from "react";
import confetti from "canvas-confetti";

export default function Celebration({ celebrationName = null, setCelebrationName }) {
  const [visible, setVisible] = useState(celebrationName != null);
  const [fadingOut, setFadingOut] = useState(false);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");

  const messages = [
    { title: "Parabéns, {{name}}! 👏🚀", subtitle: "Venda com maestria!" },
    { title: "Você brilhou, {{name}}! 🌟", subtitle: "Mais uma venda de sucesso!" },
    { title: "Fechamento sensacional! 💼🔥", subtitle: "Você arrasou, {{name}}!" },
    { title: "Mandou bem demais! 👊", subtitle: "{{name}}, você está impossível!" },
    { title: "Orgulho define! ✈️", subtitle: "Continue voando alto, {{name}}!" },
    { title: "Você é uma máquina! ⚙️💰", subtitle: "Resultados incríveis, {{name}}!" },
    { title: "Venda campeã! 🏆", subtitle: "Você é gigante, {{name}}!" },
    { title: "Sucesso atrás de sucesso! 🌟", subtitle: "Continue assim, {{name}}!" },
    { title: "Top demais! 🌟", subtitle: "Performance absurda, {{name}}!" },
    { title: "Inacreditável! 🏅", subtitle: "Mais uma vitória, {{name}}!" },
    { title: "Que performance! 🔥💪", subtitle: "Você está no seu auge, {{name}}!" },
    { title: "Você inspira! 👏✨", subtitle: "Exemplo de vendedor, {{name}}!" },
    { title: "Extraordinário! 🚀", subtitle: "Venda espetacular, {{name}}!" },
    { title: "Excelência pura! 💥", subtitle: "Venda fechada com sucesso, {{name}}!" },
    { title: "Craque das vendas! 🎯", subtitle: "Mais uma pra conta, {{name}}!" },
    { title: "Energia de campeão! 🙌", subtitle: "Você não para, {{name}}!" },
    { title: "Dominando tudo! 💥", subtitle: "Continue nesse ritmo, {{name}}!" },
    { title: "No alvo! 🎯💸", subtitle: "Parabéns pela venda, {{name}}!" }
  ];

  useEffect(() => {
    if (!celebrationName) return;

    setVisible(true);
    setFadingOut(false);

    const random = messages[Math.floor(Math.random() * messages.length)];
    const highlight = `<span class="highlight">${celebrationName}</span>`;
    setTitle(random.title.replace("{{name}}", highlight));
    setSubtitle(random.subtitle.replace("{{name}}", highlight));

    // Confetes
    const duration = 3000;
    const end = Date.now() + duration;
    (function frame() {
      confetti({ particleCount: 5, angle: 60, spread: 55, origin: { x: 0 } });
      confetti({ particleCount: 5, angle: 120, spread: 55, origin: { x: 1 } });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();

    // Áudio
    const audio = new Audio("/audio/celebration.mp3");
    audio.play().catch((e) => console.warn("Falha ao reproduzir som:", e));

    // Fade-out
    const timeout = setTimeout(() => {
      setFadingOut(true);
      setTimeout(() => {
        setVisible(false);
        setCelebrationName(null);
      }, 600);
    }, duration);

    return () => clearTimeout(timeout);
  // eslint-disable-next-line
  }, [celebrationName, setCelebrationName]);

  return (
    <>
      {visible && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            pointerEvents: "none",
            background: "rgba(0,0,0,0.3)"
          }}
        >
          <div className={`celebration-message ${fadingOut ? "fade-out" : ""}`}>
            <div className="celebration-title" dangerouslySetInnerHTML={{ __html: title }} />
            <div className="celebration-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          </div>

          <style>{`
            .celebration-message {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              text-align: center;
              color: #fff;
              text-shadow: 2px 2px 15px rgba(0,0,0,0.7);
              animation: popIn 0.8s ease-out forwards, pulseGlow 2s infinite alternate;
              opacity: 1;
              transition: opacity 0.6s ease;
            }
            .celebration-message.fade-out { opacity: 0; }
            .celebration-title { font-size: 2.5rem; font-weight: 900; margin-bottom: 0.5rem; animation: bounceIn 1s ease; white-space: nowrap; }
            .celebration-subtitle { font-size: 1.2rem; font-weight: 600; }
            .highlight { color: #ffeb3b; font-weight: 900; }
            @keyframes popIn { 0% { opacity: 0; transform: scale(0.5) translate(-50%, -50%); } 100% { opacity: 1; transform: scale(1) translate(-50%, -50%); } }
            @keyframes pulseGlow { from { text-shadow: 0 0 10px #ff4081, 0 0 20px #ff4081; } to { text-shadow: 0 0 20px #ffeb3b, 0 0 40px #ffeb3b; } }
            @keyframes bounceIn { 0% { transform: scale(0.3); opacity: 0; } 50% { transform: scale(1.2); opacity: 1; } 70% { transform: scale(0.9); } 100% { transform: scale(1); } }
          `}</style>
        </div>
      )}
    </>
  );
}
